export default "__VITE_ASSET__58be0cc7__"